import { createContext } from "react";
const WysiwygContext = /*#__PURE__*/ createContext({
    apiUrl: '',
    envVars: {
        allowDirectVideoLinks: false
    }
});
export { WysiwygContext };
